module.exports = __webpack_public_path__ + "static/media/slick.f38b2db1.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/slick.css
// module id = 1293
// module chunks = 0